import { CREATE_SERVICE_WORTH, CREATE_SERVICE_WORTH_SUCCESS, CREATE_SERVICE_WORTH_ERROR, CREATE_SERVICE_WORTH_EMPTY } from './../../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CreateServiceWorth = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_SERVICE_WORTH:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CREATE_SERVICE_WORTH_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CREATE_SERVICE_WORTH_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CREATE_SERVICE_WORTH_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CreateServiceWorth;
